import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Select} from "antd";
import {getDispensaryList, selectDispensary} from "./actions";

const Option = Select.Option;

class DispensarySelector extends Component {
  componentDidMount() {
    this.props.getDispensaryList();
  }

  _onDispensaryChange = (value) => {
    this.props.selectDispensary(value);
  };

  render() {
    const {selectedDispensaryId, dispensaryList} = this.props;
    return <Select value={selectedDispensaryId || undefined}
                   onChange={this._onDispensaryChange}
                   placeholder="Select dispensary"
                   style={{width: '100%'}}>
      {dispensaryList.map(dispensary =>
        <Option key={dispensary.dispensaryId}
                value={dispensary.dispensaryId}>
          {dispensary.name}
        </Option>
      )}
    </Select>;
  }
}

DispensarySelector.propTypes = {
  selectDispensary: PropTypes.func.isRequired,
  dispensaryList: PropTypes.array.isRequired,
  selectedDispensaryId: PropTypes.string.isRequired,
  getDispensaryList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  dispensaryList: state.dispensary.dispensaryList,
  selectedDispensaryId: state.dispensary.selectedDispensaryId,
});

const mapDispatchToProps = dispatch => ({
  getDispensaryList: bindActionCreators(getDispensaryList, dispatch),
  selectDispensary: bindActionCreators(selectDispensary, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DispensarySelector);



// WEBPACK FOOTER //
// ./src/Dispensary/DispensarySelector.js